// Attribute words for the intro sequence — pure typographic reveal, no portraits.
// Each word flashes in sequence with a metallic gold sheen, culminating in the name reveal.

export const INTRO_WORDS = [
  'ADVOCATE',
  'COUNSEL',
  'STRATEGIST',
  'LITIGATOR',
  'ARCHITECT',
  'PRECISE',
  'RESOLUTE',
  'PRINCIPLED',
  'TENACIOUS',
  'RELENTLESS',
  'PERSUASIVE',
  'JUST',
];
